@use './common' as vars;

.intro_v1 {
    @include vars.main;
}
